import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, DatePicker, Form, Modal } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useCreateTransportCostPerKm } from 'api/transports/use-create-transport-cost-per-km';
import type { ICreateCostsPerKmFormFields } from './types';

export const CostsPerKmCreate = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [form] = Form.useForm<ICreateCostsPerKmFormFields>();
  const { mutateAsync: createCostsPerKm, isLoading } = useCreateTransportCostPerKm();

  const handleOpen = () => setIsOpen(true);

  const handleClose = () => {
    form.resetFields();
    setIsOpen(false);
  };

  const handleOk = () => form.submit();

  const handleFinish = async (values: ICreateCostsPerKmFormFields) => {
    const date = values.affectedMonthBeginningDate.startOf('month').format('YYYY-MM-DD');

    await createCostsPerKm({
      affectedMonthBeginningDate: date,
    });

    handleClose();
  };

  return (
    <>
      <Button type='primary' icon={<PlusOutlined />} onClick={handleOpen}>
        {t('km-cost:create_costs_per_km')}
      </Button>
      <Modal
        title={t('km-cost:create_costs_per_km')}
        open={isOpen}
        confirmLoading={isLoading}
        onCancel={handleClose}
        onOk={handleOk}>
        <Form form={form} layout='vertical' onFinish={handleFinish}>
          <Form.Item name='affectedMonthBeginningDate' label={t('km-cost:month')} rules={[{ required: true }]}>
            <DatePicker picker='month' />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
